import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle,
} from '@material-ui/core';
import { t } from 'src/lib/language';
import { useSelector } from 'react-redux';
import { Store, useAppDispatch } from 'src/redux/Store';
import { DIALOGS } from 'src/models/DialogModel';
import { closeDialog } from 'src/redux/actions/dialogActions';
import { deleteAccountsAction } from 'src/redux/actions/dataActions';

const DeleteAccountDialog = () => {
  const dispatch = useAppDispatch();

  const { opened, payload } =
    useSelector((state: Store) => {
      if (state.dialog[DIALOGS.deleteAccount]) {
        return state.dialog[DIALOGS.deleteAccount];
      }
      return { opened: false, payload: null };
    });

  const lang = useSelector((state: Store) => state.language.language ?? 'en');

  const handleCancel = () => {
    dispatch(closeDialog({ dialog: DIALOGS.deleteAccount }));
  };

  const handleOk = () => {
    dispatch(closeDialog({ dialog: DIALOGS.deleteAccount }));
    dispatch(deleteAccountsAction(payload.id));
  };

  return (
    <Dialog
      maxWidth="xs"
      aria-labelledby="deleting-account"
      open={opened}>
      <DialogTitle id="deleting-account">{t(lang, 'menus.deleting_account')}</DialogTitle>
      <DialogContent dividers>
        {t(lang, 'menus.deleting_account_confirmation')}
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleCancel} color="primary">
          {t(lang, 'misc.no')}
        </Button>
        <Button onClick={handleOk} color="primary">
          {t(lang, 'misc.yes')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteAccountDialog;
